<template lang="pug">

  .wrapper.wrapper-content.animated.fadeInRight
    .row
      .col-lg-12
        .ibox.float-e-margins
          .ibox-content
            form.form-horizontal(v-on:submit.prevent="onSubmit")
              .row
                .col-md-6
                  .form-group
                    label.col-sm-2.control-label Project type
                    .col-sm-10
                      p.form-control-static(v-if="condoId") {{ $route.params.type }}
                      select.form-control(v-else v-model="project.type_id" required)
                        option(v-for="type in projectTypes" :value="type.id") {{ type.name }}
                  .form-group
                    label.col-sm-2.control-label Project name
                    .col-sm-10
                      p.form-control-static(v-if="condoId") {{ project.name }}
                      v-autocomplete(v-else v-model="name" :items="projectNames" :component-item="va_template" :get-label="getProjectName" :auto-select-one-item="false" @change="updateProjectNames" input-class="form-control")
                  .form-group
                    label.col-sm-2.control-label Price
                    .col-sm-10
                      input.form-control(type="text" placeholder="Enter price" v-model="project.price" @blur="project.price = formatNumber(project.price)" required)
                  .form-group
                    label.col-sm-2.control-label Size
                    .col-sm-10
                      input.form-control(type="text" placeholder="Enter condo size" v-model="project.size" required)
                  .form-group
                    label.col-sm-2.control-label Floor
                    .col-sm-10
                      input.form-control(type="text" placeholder="Enter floor" v-model="project.floor" required)
                  .form-group
                    label.col-sm-2.control-label Tower
                    .col-sm-10
                      input.form-control(type="text" placeholder="Enter tower" v-model="project.tower")
                      span.help-block.m-b-none Ex. ตึก B, ทิศ xxxx, วิวสระ
                  .form-group
                    label.col-sm-2.control-label Studio
                    .col-sm-10
                      .checkbox
                        input.nomargin(type="checkbox" id="checkbox_studio" v-model="project.studio" :true-value="'1'" :false-value="'0'")
                        label(for="checkbox_studio") (If enable bedroom and bathroom has each one.)
                  .form-group(v-show="project.studio == '0'")
                    label.col-sm-2.control-label Bedroom
                    .col-sm-5
                      input.form-control(type="text" v-model="project.bedroom" placeholder="Enter number bedroom" @blur="project.bedroom = deformatNumber(project.bedroom)")
                  .form-group(v-show="project.studio == '0'")
                    label.col-sm-2.control-label Bathroom
                    .col-sm-5
                      input.form-control(type="text" v-model="project.bathroom" placeholder="Enter number bathroom" @blur="project.bathroom = deformatNumber(project.bathroom)")
                  .form-group
                    label.col-sm-2.control-label Furnishing
                    .col-sm-10
                      input.form-control(type="text" v-model="project.furnishing" placeholder="Enter furnishing")
                  .form-group
                    label.col-sm-2.control-label Electric
                    .col-sm-10
                      input.form-control(type="text" v-model="project.electric" placeholder="Enter electric")
                  .form-group
                    label.col-sm-2.control-label Remark
                    .col-sm-10
                      textarea.form-control(v-model="project.remark" placeholder="Enter remark" rows="5")
                      span.help-block.m-b-none Ex. ใกล้ bts xx

                .col-md-6
                  .form-group
                    label.col-sm-2.control-label Location
                    .col-sm-10
                      .map-container
                        gmap-map(:center="gmapOptions.center" :zoom="gmapOptions.zoom" style="width: 100%; height: 300px;" :options="gmapOptions.options")
                          gmap-marker(v-if="marker.enabled" :position="{ lat: marker.position.lat, lng: marker.position.lng }")
                  .form-group
                    label.col-sm-2.control-label Place
                    .col-sm-10
                      p.form-control-static {{ project.location ? project.location : 'No place' }}
                  .form-group
                    label.col-sm-2.control-label
                    .col-sm-5.col-xs-6
                      p.form-control-static Latitude: {{ project.latitude ? project.latitude : '-' }}
                    .col-sm-5.col-xs-6
                      p.form-control-static Longitude: {{ project.longitude ? project.longitude : '-' }}
                  .form-group
                    label.col-sm-2.control-label Owner name
                    .col-sm-10
                      input.form-control(type="text" v-model="project.owner" placeholder="Enter owner name" required)
                  .form-group
                    label.col-sm-2.control-label Phone
                    .col-sm-10
                      input.form-control(type="tel" v-model="project.phone" placeholder="Enter phone" required)
                  .form-group
                    label.col-sm-2.control-label Line ID
                    .col-sm-10
                      input.form-control(type="text" v-model="project.line" placeholder="Enter line")
                  .form-group
                    label.col-sm-2.control-label Note
                    .col-sm-10
                      textarea.form-control(v-model="project.note" placeholder="Enter note" rows="5")
                  .form-group
                    label.col-sm-2.control-label Pin to top
                    .col-sm-10
                      .checkbox
                        input.nomargin(type="checkbox" id="checkbox_top" v-model="project.pintop" :true-value="'1'" :false-value="'0'")
                        label(for="checkbox_top") (Move this project to top of table.)
                  .form-group
                    label.col-sm-2.control-label Photos
                    .col-sm-10
                      //- button.btn.btn-outline.btn-white(type="button") Browse image
                      upload(class="btn btn-outline btn-white" :url="`${baseUrl}s3/upload/processs3.php`" :crop="false" :multiple="true" @imageuploaded="addPic" @imageuploading="upload") <i v-show="uploading" class="fa fa-spinner fa-pulse fa-fw"></i> {{ uploading ? 'Uploading...' : 'Upload Image'}}
                      ul.photos
                        li(v-for="(pic, index) in project.pictures")
                          img(v-lazy="pic.path")
                          .del(@click="deletePic(index)"): i.text-warning.fa.fa-times.fa-2x
              .row
                .col-xs-12
                  hr
                  button.btn.btn-primary(type="submit" :disabled="uploading")
                    span(v-if="condoId") Save change
                    span(v-else) Create project
                  | &nbsp;&nbsp;
                  button.btn.btn-white(type="button" @click="$router.go(-1)") Cancel
          //- .ibox-footer(v-show="project.update_by")
            .row
              .col-xs-12 <b>Update by</b> {{ project.update_by }} ({{ formatDate(project.update_date) }})
          .ibox-footer(v-if="$ls.get('user').role_name == 'Super Admin' || $ls.get('user').role_name == 'Admin' || $ls.get('user').role_name == 'Operator'")
            .row
              .col-xs-12
                span(v-if="project.seller_name") Sale: {{ project.seller_name }}
                span Admin: {{ project.create_by ? project.create_by : '-' }} {{ formatDate2(project.create_date) }}

</template>

<script>
  import axios from 'axios'
  import swal from 'sweetalert2'
  import 'sweetalert2/dist/sweetalert2.min.css'
  import toastr from 'toastr'
  import 'toastr/build/toastr.min.css'
  import vaTemplate from '@/components/vauto-projectName.vue'
  import numeral from 'numeral'
  import VueCoreImageUpload from 'vue-core-image-upload'
  import moment from 'moment'

  export default {
    components: {
      'upload': VueCoreImageUpload
    },
    data () {
      return {
        baseUrl: global.baseUrl,
        uploading: false,
        // headers: { 'Authorization': this.$ls.get('token') },
        condoId: this.$route.params.id,
        projectNames: [],
        projectNamesOptions: {
          keyword: '',
          limit: 5
        },
        projectTypes: [],
        project: {},
        gmapOptions: {
          center: {
            lat: 13.724561,
            lng: 100.4930269
          },
          zoom: 12,
          options: {
            scrollwheel: false,
            mapTypeControl: false,
            streetViewControl: false
          }
        },
        marker: {},
        name: { title: null },
        va_template: vaTemplate
      }
    },
    created () {
      if (this.condoId === undefined) {
        this.fetchProjectType()
        // this.fetchProjectName()
        this.updateProjectNames()
      }
    },
    mounted () {
      if (this.condoId) this.fetchProject()
      else {
        this.project = {
          id: null,
          title_id: null,
          price: null,
          size: null,
          floor: null,
          tower: null,
          studio: '0',
          bedroom: null,
          bathroom: null,
          furnishing: null,
          electric: null,
          remark: null,
          owner: null,
          phone: null,
          line: null,
          note: null,
          pintop: null,
          location: null,
          latitude: null,
          longitude: null,
          cat_id: 1,
          type_id: this.$route.params.type === 'rent' ? '1' : '2',
          create_by_id: this.$ls.get('user').id,
          pictures: []
        }
        this.marker = {
          enabled: false,
          position: {
            lat: 0,
            lng: 0
          }
        }
      }
    },
    methods: {
      formatNumber (number) {
        return numeral(number).format('0,0 $')
      },
      deformatNumber (number) {
        return numeral(number).value()
      },
      formatDate (date) {
        return moment(date).format('MMMM Do YYYY, h:mm:ss a')
      },

      formatDate2 (datetime) {
        return moment(datetime).format('D/M/YYYY hh:mm')
      },

      fetchProjectName () {
        axios.get(`project/title/list?keyword=${this.projectNamesOptions.keyword}&limit=${this.projectNamesOptions.limit}`).then((res) => {
          switch (res.data.responseCode) {
            case 200:
              this.projectNames = res.data.data
              console.log(this.projectNames)
              break
            case 405:
              toastr.error('This account has login by other.', res.data.message, { timeOut: 4000 })
              this.$router.push('/login')
              break
            case 406:
              toastr.error('This account has been deleted please contact admin.', res.data.message, { timeOut: 4000 })
              this.$router.push('/login')
              break
            default:
              console.log(res.data.message)
          }
        })
      },
      fetchProjectType () {
        axios.get('project/type').then((res) => {
          switch (res.data.responseCode) {
            case 200:
              this.projectTypes = res.data.data
              console.log(this.projectTypes)
              break
            case 405:
              toastr.error('This account has login by other.', res.data.message, { timeOut: 4000 })
              this.$router.push('/login')
              break
            case 406:
              toastr.error('This account has been deleted please contact admin.', res.data.message, { timeOut: 4000 })
              this.$router.push('/login')
              break
            default:
              console.log(res.data.message)
          }
        })
      },
      fetchProject () {
        axios.get(`project/id/${this.condoId}`).then((res) => {
          switch (res.data.responseCode) {
            case 200:
              this.project = res.data.data
              this.project.update_by_id = this.$ls.get('user').id
              this.project.price = this.formatNumber(this.project.price)
              if (this.project.latitude && this.project.longitude) {
                this.gmapOptions.center = { lat: Number(this.project.latitude), lng: Number(this.project.longitude) }
                this.marker.enabled = true
                this.marker.position = {
                  lat: Number(this.project.latitude),
                  lng: Number(this.project.longitude)
                }
              }
              console.log(this.project)
              break
            case 405:
              toastr.error('This account has login by other.', res.data.message, { timeOut: 4000 })
              this.$router.push('/login')
              break
            case 406:
              toastr.error('This account has been deleted please contact admin.', res.data.message, { timeOut: 4000 })
              this.$router.push('/login')
              break
            default:
              console.log(res.data.message)
          }
        })
      },
      getProjectName (item) {
        if (item.title !== null) {
          this.project.title_id = item.id
          this.project.location = item.location
          this.project.latitude = item.latitude
          this.project.longitude = item.longitude
          this.marker.enabled = true
          this.marker.position = {
            lat: Number(item.latitude),
            lng: Number(item.longitude)
          }
          this.gmapOptions.center = {
            lat: Number(item.latitude),
            lng: Number(item.longitude)
          }
          return item.title
        }
      },
      updateProjectNames (item) {
        // console.log(item)
        if (item === '') {
          this.projectNames = []
        } else {
          this.projectNamesOptions.keyword = item
          this.fetchProjectName()
        }
      },
      onSubmit () {
        this.project.price = this.deformatNumber(this.project.price)
        if (this.project.studio === '1') {
          this.project.bedroom = 1
          this.project.bathroom = 1
        }
        console.log(this.project)
        if (this.condoId) {
          // Edit
          axios.put('project', this.project).then((res) => {
            console.log(res)
            switch (res.data.responseCode) {
              case 200:
                toastr.success('Success.', res.data.message, { timeOut: 2000 })
                this.$router.go(-1)
                break
              case 405:
                toastr.error('This account has login by other.', res.data.message, { timeOut: 4000 })
                this.$router.push('/login')
                break
              case 406:
                toastr.error('This account has been deleted please contact admin.', res.data.message, { timeOut: 4000 })
                this.$router.push('/login')
                break
              default:
                console.log(res.data.message)
            }
          })
        } else {
          // Create
          axios.post('project', this.project).then((res) => {
            switch (res.data.responseCode) {
              case 200:
                toastr.success('Success.', res.data.message, { timeOut: 2000 })
                console.log(res.data)
                this.$router.go(-1)
                break
              case 405:
                toastr.error('This account has login by other.', res.data.message, { timeOut: 4000 })
                this.$router.push('/login')
                break
              case 406:
                toastr.error('This account has been deleted please contact admin.', res.data.message, { timeOut: 4000 })
                this.$router.push('/login')
                break
              default:
                console.log(res.data.message)
            }
          })
        }
      },
      upload () {
        this.uploading = true
      },
      addPic (res) {
        // Add
        for (var pic of res.images) {
          this.project.pictures.push({
            id: null,
            path: pic.src,
            title: pic.title
          })
        }
        this.uploading = false
        // this.project.pictures.push()
      },
      deletePic (index) {
        var _this = this
        swal({
          title: 'Are you sure?' + index,
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Delete!',
          cancelButtonText: 'No'
        }).then(function () {
          _this.project.pictures.splice(index, 1)
        }, function (dismiss) {
          if (dismiss === 'cancel') {
            swal(
              'Cancelled',
              'error'
            )
          }
        })
      }
    }
  }
</script>

<style lang="less" scoped>
  .nomargin {
    margin-left: 0 !important;
  }

  .photos {
    list-style: none;
    margin: 10px 0;
    padding: 0;

    > li {
      float: left;
      position: relative;
      width: 120px;
      height: 120px;
      background-color: #EEE;
      margin: 0px 10px 10px 0;
      overflow: hidden;

      img {
        max-width: 100%;
        max-height: 100%;
      }

      .del {
        position: absolute;
        top: 2px;
        right: 5px;
      }
    }
  }
</style>




// WEBPACK FOOTER //
// edit.vue?0bbf1198